const xmljs = require("xml-js");

/**
 * NFe V4.00
 * @param {string} xml
 * @returns {{
 *   _attributes: { encoding: string, version: string },
 *   nfeProc: {
 *     _attributes: { versao: string, xmlns: string },
 *     NFe: {
 *       _attributes: { xmlns: string },
 *       infNFe: {
 *         _attributes: { versao: string, Id: string },
 *         ide: {
 *           cUF: { _text: string },
 *           cNF: { _text: string },
 *           natOp: { _text: string },
 *           mod: { _text: string },
 *           serie: { _text: string },
 *           nNF: { _text: string },
 *           dhEmi: { _text: string },
 *           dhSaiEnt: { _text: string },
 *           tpNF: { _text: string },
 *           idDest: { _text: string },
 *           cMunFG: { _text: string },
 *           tpImp: { _text: string },
 *           tpEmis: { _text: string },
 *           cDV: { _text: string },
 *           tpAmb: { _text: string },
 *           finNFe: { _text: string },
 *           indFinal: { _text: string },
 *           indPres: { _text: string },
 *           procEmi: { _text: string },
 *           verProc: { _text: string },
 *         },
 *         emit: {
 *           CNPJ: { _text: string },
 *           xNome: { _text: string },
 *           xFant: { _text: string },
 *           enderEmit: {
 *           xLgr: { _text: string },
 *             nro: { _text: string },
 *             xBairro: { _text: string },
 *             cMun: { _text: string },
 *             xMun: { _text: string },
 *             UF: { _text: string },
 *             CEP: { _text: string },
 *             cPais: { _text: string },
 *             xPais: { _text: string },
 *             fone: { _text: string },
 *           },
 *         IE: { _text: string },
 *         CRT: { _text: string }
 *       },
 *       dest: {
 *         CNPJ: { _text: string },
 *         xNome: { _text: string },
 *         enderDest: {
 *           xLgr: { _text: string },
 *           nro: { _text: string },
 *           xBairro: { _text: string },
 *           cMun: { _text: string },
 *           xMun: { _text: string },
 *           UF: { _text: string },
 *           CEP: { _text: string },
 *           cPais: { _text: string },
 *           xPais: { _text: string },
 *           fone: { _text: string },
 *         },
 *         indIEDest: { _text:string },
 *         email: { _text: string }
 *       },
 *       det: {
 *         _attributes: { nItem: string },
 *         prod: {
 *           cProd: { _text: string },
 *           cEAN: { _text: string },
 *           xProd: { _text: string },
 *           NCM: { _text: string },
 *           CEST: { _text: string },
 *           CFOP: { _text: string },
 *           uCom: { _text: string },
 *           qCom: { _text: string },
 *           vUnCom: { _text:string },
 *           vProd: { _text: string },
 *           cEANTrib: { _text: string },
 *           uTrib: { _text: string },
 *           qTrib: { _text: string },
 *           vUnTrib: { _text: string },
 *           vDesc: { _text: string },
 *           indTot: { _text: string },
 *           xPed: { _text: string },
 *           nItemPed: { _text: string },
 *         },
 *         imposto: {
 *           ICMS: {
 *             ICMS40: { orig: { _text: string },
 *             CST: { _text: string },
 *             vICMSDeson: { _text: string },
 *             motDesICMS: { _text: string },
 *           },
 *         },
 *         IPI: {
 *           cEnq: { _text: string },
 *           IPITrib: {
 *             CST: { _text: string },
 *             qUnid: { _text: string },
 *             vUnid: { _text: string },
 *             vIPI: { _text: string },
 *           },
 *         },
 *         II: {
 *           vBC: { _text: string   },
 *           vDespAdu: { _text: string },
 *           vII: { _text: string },
 *           vIOF: { _text: string },
 *         },
 *         PIS: {
 *           PISAliq: {
 *           CST: { _text: string },
 *           vBC: { _text: string },
 *           pPIS: { _text: string },
 *           vPIS: { _text: string },
 *         },
 *       },
 *       COFINS: {
 *         COFINSAliq: {
 *           CST: { _text: string },
 *           vBC: { _text: string },
 *           pCOFINS: { _text: string },
 *           vCOFINS: { _text: string },
 *           },
 *         },
 *       },
 *     }[],
 *     total: {
 *       ICMSTot: {
 *         vBC: { _text: string },
 *         vICMS: { _text: string },
 *           vICMSDeson: { _text: string },
 *           vFCP: { _text: string },
 *           vBCST: { _text: string },
 *           vST: { _text: string },
 *           vFCPST: { _text: string },
 *           vFCPSTRet: { _text: string },
 *           vProd: { _text: string },
 *           vFrete: { _text: string },
 *           vSeg: { _text: string },
 *           vDesc: { _text: string },
 *           vII: { _text: string },
 *           vIPI: { _text: string },
 *           vIPIDevol: { _text: string },
 *           vPIS: { _text: string },
 *           vCOFINS: { _text: string },
 *           vOutro: { _text: string },
 *           vNF: { _text: string },
 *         },
 *       },
 *       transp: {
 *         modFrete: { _text: string },
 *         vol: {
 *           qVol: { _text: string },
 *           pesoL: { _text: string },
 *           pesoB: { _text: string },
 *         },
 *       },
 *       cobr: {
 *         fat: {
 *           nFat: { _text: string },
 *             vOrig: { _text: string },
 *             vDesc: { _text: string },
 *             vLiq: { _text: string },
 *           },
 *           dup: {
 *             nDup: { _text: string },
 *             dVenc: { _text: string },
 *             vDup: { _text: string },
 *           },
 *         },
 *         pag: {
 *           detPag: {
 *             tPag: { _text: string },
 *             vPag: { _text: string },
 *             card: {
 *               tpIntegra: { _text: string },
 *               CNPJ: { _text: string },
 *               tBand: { _text: string },
 *               cAut: { _text: string },
 *             },
 *           },
 *         },
 *         infAdic: { infCpl: { _text: string } },
 *       },
 *       Signature: {
 *         _attributes: { xmlns: string },
 *         SignedInfo: {
 *           CanonicalizationMethod: {
 *             _attributes: { Algorithm: string } },
 *           },
 *           SignatureMethod: { _attributes: { Algorithm: string } },
 *           Reference: {
 *             _attributes: { URI: string },
 *             Transforms: {
 *               Transform: { _attributes: { Algorithm: string } }[],
 *             },
 *             DigestMethod: {
 *               _attributes: { Algorithm: string }
 *             },
 *             DigestValue: { _text: string },
 *           },
 *         },
 *         SignatureValue: { _text: string },
 *         KeyInfo: {
 *           X509Data: {
 *             X509Certificate: { _text: },
 *           },
 *         },
 *       },
 *     },
 *     protNFe: {
 *       _attributes: { versao: string, xmlns: string },
 *       infProt: { tpAmb: { _text: string },
 *       verAplic: { _text: string },
 *       chNFe: { _text: string },
 *       dhRecbto: { _text: string },
 *       nProt: { _text: string },
 *       digVal: { _text: string},
 *       cStat: { _text: string },
 *       xMotivo: { _text: string }
 *     },
 *   },
 * }}
 */
function parseNFeV4(xml) {
  try {
    let nfe = xmljs.xml2js(xml, { compact: true });

    // caso só exista um produto no xml, ele acaba sendo renderizado como um objeto em infNFe
    // esse bloco colocar ele dentro de um array

    let { nfeProc } = nfe;

    let nf = null
    if (!nfeProc) {
      nf = {
        nfeProc: nfe
      }
    } else {
      nf = nfe
    }

    if (!Array.isArray(nf.nfeProc.NFe.infNFe.det)) {
      const obj = Object.freeze(nf.nfeProc.NFe.infNFe.det);
      delete nf.nfeProc.NFe.infNFe.det;
      nf.nfeProc.NFe.infNFe.det = [obj];
    }

    return nf;
  } catch (error) {
    alert("Tipo de nota fiscal inválida");
  }
}

module.exports = parseNFeV4;
